import { memo, useEffect, useLayoutEffect, useRef, useState } from 'react';
import styles from './index.module.scss';

const CustomScroll = ({ children }: any) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const contentRef = useRef<HTMLDivElement>(null);
  const animationRef = useRef<number>();
  const [isScrolling, setIsScrolling] = useState(true);
  const [isDragging, setIsDragging] = useState(false);
  const [startX, setStartX] = useState(0);
  const [scrollLeftStart, setScrollLeftStart] = useState(0);
  const [contentWidth, setContentWidth] = useState(0);

  useLayoutEffect(() => {
    if (contentRef.current) {
      setContentWidth(contentRef.current.offsetWidth / 2); // 单份内容宽度
      containerRef.current!.scrollLeft = 0;
    }
  }, []);

  const step = () => {
    if (containerRef.current) {
      containerRef.current.scrollLeft += 1;
      if (containerRef.current.scrollLeft >= contentWidth) {
        containerRef.current.scrollLeft -= contentWidth;
      }
    }
    animationRef.current = requestAnimationFrame(step);
  };

  useEffect(() => {
    if (isScrolling) {
      animationRef.current = requestAnimationFrame(step);
    }
    return () => {
      if (animationRef.current) cancelAnimationFrame(animationRef.current);
    };
  }, [isScrolling, contentWidth]);

  // Touch事件处理
  const handleTouchStart = (e: React.TouchEvent) => {
    setIsDragging(true);
    setIsScrolling(false);
    setStartX(e.touches[0].clientX);
    setScrollLeftStart(containerRef.current!.scrollLeft);
  };

  const handleTouchMove = (e: React.TouchEvent) => {
    if (!isDragging || !containerRef.current) return;
    const deltaX = e.touches[0].clientX - startX;
    containerRef.current.scrollLeft = scrollLeftStart - deltaX;

    // 无限循环位置修正
    if (containerRef.current.scrollLeft >= contentWidth) {
      containerRef.current.scrollLeft -= contentWidth;
      setScrollLeftStart(prev => prev - contentWidth);
    } else if (containerRef.current.scrollLeft <= 0) {
      containerRef.current.scrollLeft += contentWidth;
      setScrollLeftStart(prev => prev + contentWidth);
    }
  };

  const handleTouchEnd = () => {
    setIsDragging(false);
    setIsScrolling(true);
  };

  return (
    <div
      ref={containerRef}
      className={styles.customScroll}
      onTouchStart={handleTouchStart}
      onTouchMove={handleTouchMove}
      onTouchEnd={handleTouchEnd}
      onTouchCancel={handleTouchEnd}
    >
      <div className={styles.carouselContent} ref={contentRef}>
        <div className={styles.list}>
          {children}
          {children}
        </div>
      </div>
    </div>
  )
};

export default memo(CustomScroll);
